import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.254 16.615V24.115C11.254 24.525 11.594 24.865 12.004 24.865H19.504C19.914 24.865 20.254 24.525 20.254 24.115V16.615C20.254 16.205 19.914 15.865 19.504 15.865H12.004C11.594 15.865 11.254 16.205 11.254 16.615ZM12.754 17.365H18.754V23.365H12.754V17.365Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M31.294 16.095L16.294 0.225C16.014 -0.075 15.484 -0.075 15.204 0.225L0.203976 16.095C-0.00602438 16.315 -0.0560238 16.635 0.0639762 16.905C0.183976 17.175 0.453976 17.355 0.753976 17.355H5.63398V30.735C5.63398 31.145 5.97398 31.485 6.38398 31.485H25.134C25.544 31.485 25.884 31.145 25.884 30.735V17.355H30.764C31.064 17.355 31.334 17.175 31.454 16.905C31.574 16.625 31.514 16.315 31.314 16.095H31.294ZM25.134 15.865C24.724 15.865 24.384 16.205 24.384 16.615V29.995H7.13398V16.615C7.13398 16.205 6.79398 15.865 6.38398 15.865H2.50398L15.764 1.835L29.024 15.865H25.144H25.134Z",
		fill: "currentColor"
	})]
});
export default SvgHome;
